import React from 'react'

import { TABLE_ESTADO_ELEVADOR } from '../../../config/tables'
import Movimiento from '../../../models/movimiento/movimientoService'
import { MovimientoUtils } from '../../../models/movimiento/movimientoUtils'
import DetallesSiloDialog from '../../CuadroDeMandoMovimientos/containers/DetallesSiloDialog'

export const EMPTY_SILO_OPERANDO = {
}

export function updateTablaSilosEstadoElevador (newState) {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState,
      id: TABLE_ESTADO_ELEVADOR
    })
  }
}

export function updateGraFicoSilos (newState) {
  return dispatch => {
    dispatch({
      type: 'UPDATE_SILOS_3D',
      newState
    })
  }
}

export function clickedSilo (silo) {
  return async dispatch => {
    const detallesMovimientosSilo = (await Movimiento.getMovimiento()).filas.filter(siloLocal => siloLocal.nombre === silo.nombre)[0]
    dispatch({
      type: 'UPDATE_SILO_A_DETALLAR',
      detallesMovimientosSilo
    })
    const cancelCallback = () => {
      dispatch({
        type: 'CLOSE_DIALOG',
        id: 'DETALLES_DE_SILO'
      })
    }
    dispatch({
      type: 'OPEN_DIALOG',
      id: 'DETALLES_DE_SILO',
      maxWidth: 'sm',
      content: <DetallesSiloDialog />,
      cancelCallback
    })
  }
}

export function updateHuds (huds) {
  return dispatch => {
    dispatch({
      type: 'SET_HUDS',
      huds
    })
  }
}

export function clickedSector (sector) {
  return dispatch => {
    dispatch({
      type: 'RESET_CAMERA'
    })
    setTimeout(() => {
      dispatch({
        type: 'SELECT_SECTOR',
        sector: sector
      })
    }, 1)
  }
}

export function parseData (data) {
  return MovimientoUtils.parseData(data)
}
